import React, { memo } from "react";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../../../2_ksbHub/context/appContext";
import { CustomTextField } from "./CustomTextField";
import ErrorBox from "./ErrorBox";

function AufwandBoxComponent({
  classView,
  restricted,
  my_minutes,
  suggested_minutes,
  type,
  workloadErr,
  personalView,
  change,
}) {
  // console.log("classView: ", classView)
  const theme = useTheme();
  const { appInDarkMode } = useAppContext();

  return (
    <>
      {/* Aufwand */}
      <CustomTextField
        id={personalView ? "myaufwand" : "aufwand"}
        placeholder="Aufwand"
        label={
          personalView
            ? "myAufwand min"
            : restricted || type === "personal"
              ? "geplanter Aufwand"
              : "Aufwand SuS"
        }
        fullWidth
        variant="outlined"
        //
        autoFocus={false}
        type="number"
        // helperText="eingeplant"
        value={
          personalView
            ? my_minutes
            : //students can change this value box, it will change workloadminutesTotal
              (restricted && my_minutes === -1) || (classView && restricted)
              ? suggested_minutes
              : restricted
                ? my_minutes
                : !restricted && type === "personal"
                  ? my_minutes
                  : suggested_minutes
        }
        disabled={classView && restricted}
        onChange={change}
        inputProps={{ style: { fontSize: "0.9em" } }}
        appindarkmode={appInDarkMode.toString()}
        paper={theme.palette.background.paper}
        white={theme.palette.levels.white}
        dark={theme.palette.levels.dark}
      />
      <ErrorBox error={workloadErr} />
    </>
  );
}

export default memo(AufwandBoxComponent);
